import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getOrderMSNoteListData } from './mockData'
import type { IOrderMSNote } from '~/types/note/models'

export const {
  getNotes: getOrderMSNotes,
  postNote: postOrderMSNote,
  patchNote: patchOrderMSNote,
  deleteNote: deleteOrderMSNote,
  handlers,
} = makeNoteAPIs<IOrderMSNote>({
  apiPathEntityNamePrefix: 'orderms',
  getNoteListDataFn: getOrderMSNoteListData,
})
